
import { Injectable } from '@angular/core';
import { HttpClient,  HttpHeaders } from '@angular/common/http';
import { ToastController } from 'ionic-angular';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/share';

import { Observer } from 'rxjs/Observer';
import { Observable } from 'rxjs/Observable';

let apiUrl = 'http://integra02.connectparts.com.br:8032';

@Injectable()
export class AuthServiceProvider {

 public token: any;
  public user: any;
public Logged: any;
public userDetail: any;

userChange: Observable<any>;
userChangeObserver: Observer<any>;

  constructor(public http: HttpClient, public toastCtrl: ToastController) {

    console.log('Hello AuthServiceProvider Provider');

    this.userChange = new Observable((observer: Observer<any>) => {
      this.userChangeObserver = observer;
    });

  }

  login(data) {

    return new Promise((resolve, reject) => {

      this.http.get(apiUrl + '/OAuth/Token?username='+ data.usuario +'&password=' + data.senha)
               .subscribe((result: any) => {

                  resolve(result);

                  this.user = result;

                  localStorage.setItem('userLogin', this.user);
                  localStorage.setItem('userToken', this.user.access_token);

                  this.getUserDetail(result.user_id);

               },
                (error) => {

                  reject(error);

                  let toast = this.toastCtrl.create({
                    message: error.error,
                    duration: 3000
                  });

                  toast.present();

               });

    });
  }

  getUserDetail(userID) {

    return new Promise((resolve, reject) => {

      const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') });

      this.http.get(apiUrl + '/Usuario/Buscar?rdenarPor=nome&deslocamento' + userID, { headers: header })
               .subscribe((result: any) => {

                  resolve(result);

                  this.userDetail = result
                  localStorage.setItem('userData', JSON.stringify(this.userDetail));

                },
                (error) => {

                  reject(error);

                  let toast = this.toastCtrl.create({
                    message: error.error,
                    duration: 3000
                  });
                  toast.present();

                });

    });
  }

  getUserLogged() {

    return new Promise((resolve, reject) => {

      const user = JSON.parse(localStorage.getItem('userData'));
      this.Logged = user[0];

      this.http.get(apiUrl + '/Usuario/Autenticar?username=' + this.Logged.Login + '&password=' + this.Logged.Senha)
               .subscribe((result: any) => {

                  resolve(result);

               },
                (error) => {

                  reject(error);

                  let toast = this.toastCtrl.create({
                    message: error.error,
                    duration: 3000
                  });
                  toast.present();

               });

    });

  }

}



// WEBPACK FOOTER //
// ./src/providers/auth-service/auth-service.ts